import { createAction } from "@reduxjs/toolkit"

import { BALANCE_SLICE_NAME } from "./balance.constants"

export const topUpBalanceSuccess = createAction(`${BALANCE_SLICE_NAME}/topUpBalanceSuccess`)
